import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function ChargesBreakdownSection({ storageCharges, taxCharges, billingCharges }) {
  const storageTotal = storageCharges.total || 0;
  const taxTotal = taxCharges.total || 0;
  const grandTotal = billingCharges.grand_total || 0;

  const formatCurrency = (amount) => {
    const num = typeof amount === "number" ? amount : parseFloat(amount) || 0;
    return `$${num.toFixed(2)}`;
  };

  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      width="100%"
      sx={{ 
        py: 3,
        gap: 2
      }}
    >
      {/* Storage Charges */}
      <Box 
        display="flex" 
        justifyContent="space-between" 
        alignItems="center"
        sx={{ 
          pb: 2,
          borderBottom: "1px dotted",
          borderColor: "grey.500"
        }}
      >
        <Typography variant="body1" fontSize="16px" color="text.primary">
          Storage Charges
        </Typography>
        <Typography variant="body1" fontSize="16px" fontWeight={400} color="text.primary">
          {formatCurrency(storageTotal)}
        </Typography>
      </Box>

      {/* Sales Tax */}
      <Box 
        display="flex" 
        justifyContent="space-between" 
        alignItems="center"
        sx={{ 
          pb: 2,
          borderBottom: "1px dotted",
          borderColor: "grey.500"
        }}
      >
        <Typography variant="body1" fontSize="16px" color="text.primary">
          Sales Tax
        </Typography>
        <Typography variant="body1" fontSize="16px" fontWeight={400} color="text.primary">
          {formatCurrency(taxTotal)}
        </Typography>
      </Box>

      {/* Grand Total */}
      <Box 
        display="flex" 
        justifyContent="space-between" 
        alignItems="center"
        sx={{ pt: 1 }}
      >
        <Typography variant="body1" fontSize="16px" fontWeight={500} color="text.primary">
          Grand Total
        </Typography>
        <Typography variant="body1" fontSize="16px" fontWeight={500} color="text.primary">
          {formatCurrency(grandTotal)}
        </Typography>
      </Box>
    </Box>
  );
}
